import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  root: {
    position: "fixed",
    zIndex: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    bottom: 0,
    left: 0,
    width: "100%",
    padding: ".5rem 1rem",
    backgroundColor: "#fff",
    boxShadow: "0 -1px 1px 0 rgba(0,0,0,0.1)",
  },
  text: {
    fontSize: ".875rem",
    color: "rgba(0,0,0,.6)",
  },
  social: {
    display: "flex",
  },
  socialLink: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 32,
    height: 32,
    margin: "0 .25rem",
    color: "#fff",
    backgroundColor: "#24bba7",
    borderRadius: "100%",
    "&:hover": {
      backgroundColor: "#1aa592",
    },
  },
  socialIconImg: {
    height: "1.125rem",
  },
});
